import {
  CreateProviderRequestBuilder,
  GetProvidersBuilder,
  GetProvidersCountBuilder,
  UpdateProviderStatusRequestBuilder,
} from '../providers/providers';

import Client from '../client';
import {flattenObject} from '../helpers';

const token = localStorage.getItem('token') || '';

class ProvidersRepository {
  getProviders = async (actions: any) => {
    const makeRequest = new GetProvidersBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetProvidersCountBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeActiveCardCountRequest = new GetProvidersCountBuilder()
      .params(
        flattenObject({
          ...actions.payload,
          sort: 'id,desc',
          'status.in': ['ACTIVE'],
        })
      )
      .build();
    const makeInactiveCardCountRequest = new GetProvidersCountBuilder()
      .params(
        flattenObject({
          ...actions.payload,
          sort: 'id,desc',
          'status.in': ['INACTIVE'],
        })
      )
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    const count = await client.execute(makeCountRequest);
    const activeCardCount = await client.execute(makeActiveCardCountRequest);
    const inactiveCardCount = await client.execute(
      makeInactiveCardCountRequest
    );
    return {response, count, activeCardCount, inactiveCardCount};
  };
  updateProviderStatus = async (actions: any) => {
    const {id, body, pagination} = actions.payload;
    const makeUpdateProviderStatusRequest =
      new UpdateProviderStatusRequestBuilder().id(id).data(body).build();
    const client = new Client(token);
    await client.execute(makeUpdateProviderStatusRequest);
    return pagination;
  };
  createProvider = async (actions: any) => {
    const {body, pagination, callback} = actions.payload;
    const makeAddProviderRequest = new CreateProviderRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeAddProviderRequest);
    return {pagination, callback};
  };
}

export default new ProvidersRepository();
